import React from "react"
import styled from "styled-components"

const LoadingIcon = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: calc(100% - 45px);
  align-items: center;
  .loader {
    width: 40px;
    height: 20px;
    position: relative;
    margin: 0 auto;
    .loader-dot {
      position: absolute;
      top: 0;
      width: 16px;
      height: 16px;
      border-radius: 100%;
      animation: pink 1.05s ease-in-out infinite;
    }
    .dot-pink {
      background: #ff8400;
      left: -2px;
    }
    .dot-blue {
      animation-name: blue;
      background: #f9bb00;
      right: -2px;
    }
  }

  @keyframes pink {
    0% {
      z-index: 1;
    }
    50% {
      transform: translateX(20px);
    }
  }
  @keyframes blue {
    50% {
      transform: translateX(-20px);
    }
  }
`

export default () => {
  return (
    <LoadingIcon>
      <div className="loader">
        <i className="loader-dot dot-pink"></i>
        <i className="loader-dot dot-blue"></i>
      </div>
    </LoadingIcon>
  )
}
